module.exports = __webpack_public_path__ + "img/about-slide-mobile.773418c2.svg";